export default "<!-- <app-sidenav></app-sidenav> -->\r\n\r\n<router-outlet></router-outlet>"